import { useState } from 'react'
import { toast } from 'sonner'
import { supabase } from '@/lib/supabase'
import { confirmDialog } from '@/lib/confirmDialog'
import Button from '@/components/common/Button'
import Badge from '@/components/common/Badge'

function ParentsList({ parents, onDelete, onEdit, teamId }) {
  const [deleting, setDeleting] = useState(null)

  const handleDelete = async (parentId) => {
    const confirmed = await confirmDialog(
      'Remove this parent?',
      { 
        confirmText: 'Remove', 
        cancelText: 'Cancel',
        description: 'They will no longer receive dispatches.'
      }
    )
    if (!confirmed) return

    setDeleting(parentId)
    try {
      const { error } = await supabase
        .from('parents')
        .delete()
        .eq('id', parentId)
        .eq('team_id', teamId)

      if (error) throw error
      onDelete()
    } catch (err) {
      console.error('Error deleting parent:', err)
      toast.error('Failed to delete parent')
    } finally {
      setDeleting(null)
    }
  }

  return (
    <div className="space-y-3">
      {parents.map((parent) => (
        <div
          key={parent.id}
          className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 p-4 bg-gray-50 border border-border rounded-lg"
        >
          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-2 flex-wrap">
              <p className="font-medium text-brand-charcoal break-words">{parent.email}</p>
              {parent.opted_out_at && (
                <Badge variant="gray">Unsubscribed</Badge>
              )}
            </div>
            {(parent.name || parent.player_name) && (
              <p className="text-sm text-brand-slate mt-1">
                {parent.name && <span>{parent.name}</span>}
                {parent.name && parent.player_name && <span> • </span>}
                {parent.player_name && <span>Player: {parent.player_name}</span>}
              </p>
            )}
          </div>
          <div className="flex gap-2 flex-shrink-0">
            <Button
              variant="secondary"
              onClick={() => onEdit(parent)}
              className="text-sm px-4 py-2"
            >
              Edit
            </Button>
            <Button
              variant="secondary"
              onClick={() => handleDelete(parent.id)}
              disabled={deleting === parent.id}
              className="text-sm px-4 py-2"
            >
              {deleting === parent.id ? 'Removing...' : 'Remove'}
            </Button>
          </div>
        </div>
      ))}
    </div>
  )
}

export default ParentsList

